import type { WorkflowTransitionApplyForm } from '.'
import { ApiService } from '~/shared/api'
import { restGetList, sendForm } from '~/shared/utils/decorators'
import type { ServiceRestGetList, ServiceCanSendForm } from '~/shared/interfaces'
import type { WorkflowTransitionsListParams } from '~/interfaces/Workflow'
import { WorkflowTransitionModel, WorkflowStatusModel } from '~/model/Workflow'
import { toModel, toModels } from '~/shared/api/utils'

// eslint-disable-next-line
interface WorkflowTransitionsService extends ServiceRestGetList, ServiceCanSendForm {}

@restGetList
@sendForm
// eslint-disable-next-line no-redeclare
class WorkflowTransitionsService extends ApiService {
  protected route: string = 'workflow/transitions'

  getListModel(params: WorkflowTransitionsListParams = {}): Promise<Array<WorkflowTransitionModel>> {
    return this.getList(params).then(toModels(WorkflowTransitionModel))
  }

  apply(form: WorkflowTransitionApplyForm): Promise<WorkflowStatusModel> {
    return this.sendForm(form, `${this.prefix}/${this.route}/apply`).then(toModel(WorkflowStatusModel))
  }
}

export default WorkflowTransitionsService
